import styled from "@emotion/styled";

const PageWrapper = styled.div`
    min-height: 100vh;
`

export { PageWrapper }